export default {
  line: "வரி",
  language: "மொழி",
  common: [
"ஆன்லைன் சேவைகள்",
"இடைநீக்கத்தை ரத்துசெய்",
"கொள்முதலைச் செய்ய 10,000 ₽ செலவிட வேண்டுமா!"
  ],
  informationHub: "SGM.s அதிகாரப்பூர்வ மையம்",
  charitables:[//慈善
  	  "SGM.s இன் அதிகாரப்பூர்வ தகவல் மையத்திற்கு வரவேற்கிறோம்! 🌟 வெளிப்படையான, அதிகாரப்பூர்வ தகவல்களுக்கான உங்கள் தளம். இங்கே, நீங்கள் எங்கள் அதிகாரப்பூர்வ சான்றிதழ்களைச் சரிபார்க்கலாம் 📜, விரிவான தகவல்களுக்கு www.sgm.top ஐப் பார்வையிடலாம் 🌐 மற்றும் சமீபத்திய புதுப்பிப்புகளுக்கு எங்கள் Telegram சேனலைப் பின்தொடரலாம்! 📲 கூடுதலாக, Yahoo, அசோசியேட்டட் பிரஸ், Google போன்ற சர்வதேச ஊடகங்களில் இருந்து SGM.s பற்றிய நேர்மறையான விமர்சனங்களையும் நீங்கள் காணலாம்! 📰 இவை அனைத்தும் SGM பிராண்ட் மற்றும் அதன் எதிர்கால வளர்ச்சி மீதான உங்கள் நம்பிக்கையை கணிசமாக அதிகரிக்கும், பகிர்வு போக்குவரத்து வணிகத்தில் நீங்கள் வெற்றிபெறவும், தொடர்ந்து கணிசமான கூடுதல் வருமானத்தைப் பெறவும் உதவும்! 💰🚀"
  	  ],
  upload: [
"பதிவேற்றுகிறது...",
"தவறான வடிவம்",
"வெற்றிகரமாக பதிவேற்றப்பட்டது",
"பதிவேற்றம் தோல்வியடைந்தது"
  ],
  details:[
  	  "பணி அலகு விலை",
  	  "ஆர்டர் எண்ணிக்கை",
  	  "தினசரி வருமானம்",
  	  "நிலை",
  	  "தினசரி லாபம்",
  	  "வைப்பு",
  	  "வைப்பு திருப்பி அனுப்பும் தேதி",
  	  "மீதமுள்ள நாட்கள்",
  	  "எனது SGM.s நிலை"
  ],
  vanPull: [
"இனி தரவு இல்லை",
"தரவு இல்லை"
  ],
  login: {
    title:'பயனர்பெயர் மற்றும் கடவுச்சொல்லுடன் உள்நுழையவும்',
    title_txt:'உங்கள் பதிவு செய்யப்பட்ட மொபைல் எண்ணைப் பயன்படுத்தி உள்நுழையவும்.',
    text: [
"பயனர்பெயர்/கடவுச்சொல்லை நினைவில் கொள்ளுங்கள்",
"உள்நுழைதல்...",
"இப்போது உள்நுழையவும்"
    ],
    placeholder: [
 "தயவுசெய்து தொலைபேசி எண்ணை உள்ளிடவும்",
"உள்நுழைவு கடவுச்சொல்லை உள்ளிடவும்"
    ],
    i18n: [
"{title} கணக்கு இல்லையா? {a} {line}",
"பதிவு செய்"
    ]
  },
  register: {
    text: [
"பதிவு செய்ய வரவேற்கிறோம்",
"எஸ்எம்எஸ் குறியீடு அனுப்புதல்...",
"எஸ்எம்எஸ் குறியீட்டைப் பெறு",
"பதிவுசெய்கிறது...",
"இப்போதே பதிவுசெய்",
"ஏற்கனவே கணக்கு உள்ளதா? இப்போதே உள்நுழை",
"மொபைல் தொலைபேசி எண் பதிவு",
"மின்னஞ்சல் பதிவு",
"உள்நுழைவுக்குத் திரும்பு",
"பதிவு செய்யப்படாத தொலைபேசி எண் மற்றும் மின்னஞ்சல் முகவரியைப் பயன்படுத்தவும்"
    ],
    placeholder: [
"தயவுசெய்து உங்கள் தொலைபேசி எண்ணை உள்ளிடவும்",
"தயவுசெய்து SMS சரிபார்ப்புக் குறியீட்டை உள்ளிடவும்",
"உள்நுழைவு கடவுச்சொல்லை உள்ளிடவும்",
"தயவுசெய்து உங்கள் கடவுச்சொல்லை உறுதிப்படுத்தவும்",
"அழைப்புக் குறியீட்டை உள்ளிடவும்",
"இரண்டு கடவுச்சொற்கள் வேறுபட்டவை",
"சரிபார்ப்புக் குறியீட்டை உள்ளிடவும்",
"மின்னஞ்சல் எண்ணை உள்ளிடவும்",
"0 உடன் தொடங்க முடியாது"
    ],
    i18n: [
"கணக்கு உள்ளதா? {a} {line}",
"உள்நுழை"
    ]
  },
  home: {
    lucky: "நிகழ்வு இன்னும் திறக்கப்படவில்லை.",
    map: "இடம்",
    qywh: "நிறுவன கலாச்சாரம்",
    broadcast: "SGM.s ஆன்லைன் பைக்-பகிர்வு திட்டத்தில் சேர ஒரு நண்பரை அழைத்ததற்கும், {vipname} ஆக பதவி உயர்வு பெற்றதற்கும், {grade} பகிர்வு வெகுமதிகளைப் பெற்றதற்கும் {member} க்கு வாழ்த்துகள்..",
    menu: [
"VIP பகுதி",
"வீடியோ பயிற்சி",
"பதவி உயர்வு வெகுமதிகள்"
    ],
    taskHall: {
      title: [
"பணி அரங்கம்",
"வணிக அரங்கம்",
"லாபம் ஈட்ட பணிகளை முடிக்கவும்"
      ]
    },
    title:['பணி','செய்திகள்','மேலும்','திற','திறத்து தொடர்ந்து பயன்படுத்தவும்~','பார்க்கவும்','வாழ்த்துக்கள்!மேம்படுத்தல் வெற்றி','வாழ்த்துக்கள்~ இரண்டு டிராப் கார்டுகளைப் பெற்றுள்ளார்.'],
    memberList: {
      title: "உறுப்பினர் பட்டியல்",
      data: [
        "{member},இன்றைய {num} ஆர்டர் பணிகளை முடிக்கவும்.!"
      ]
    },
    businessList: {
      title: "வணிகர் பட்டியல்",
      data: [
        "{member}",
        "இன்றே {num} ஒற்றைப் பணியை வெளியிடு"
      ]
    },
    noticeTitle: ["கவனிக்கவும்","முந்தையது","அடுத்து"],
    tabBar: ["முகப்பு","டெலிவரி","டி", "வரைபடம்", "எனது"],
    msg: "பணி திறக்கப்படவில்லை.",
    video: "வீடியோ பயிற்சி இல்லை",
	  message: "உங்களுக்குப் புதிய செய்திகள் உள்ளன.",
	  bonus:[
'<p>"சைக்கிளிங் குறியீடு" ரொக்க வெகுமதியைப் பெற குறியீட்டை உள்ளிடவும் (1-200000 ரூ)</p><p>1. "சைக்கிளிங் குறியீடு" நிறுவனத்தின் செயல்பாடுகள் மூலம் பெறப்படுகிறது!</p><p>2. பணிக்குழு அவ்வப்போது கடவுச்சொற்களை வெளியிடுகிறது! நீங்கள் தினசரி பணிக்குழு தகவல்களுக்கு கவனம் செலுத்தலாம்!</p><p>சைக்கிள்களை வரிசைப்படுத்துங்கள், பகிர்வு பொருளாதார வாழ்க்கையை அனுபவிக்கவும், குறியீடு பண வெகுமதிகளை எளிதாகப் பெறவும்!</p><p>விவரங்களுக்கு, "ஆட்சேர்ப்பு மேலாளரை" அணுகவும்</p>',
'கடவுச்சொல் நிறுவனத்தின் செயல்பாடுகள் மூலம் பெறப்படுகிறது!',
'சிவப்பு உறை குறியீட்டை உள்ளிடவும்',
'பணத்தைப் பெறுங்கள்',
'ரைடு கேஷ் {அளவு TJS வென்றதற்கு வாழ்த்துக்கள்',
'ரைடு கேஷ்'
	],
    helpCenter: {
      title: "Help Center",
      empty: "No help articles"
    }
  },
  vip: {
    title:[
"VIP நிலை",
"பணிகளைப் பெற இப்போதே உறுப்பினராக சேருங்கள்",
"மேம்பாட்டில் உள்ளது"
    ],
    user: {
      title: [
"உங்கள் அடையாளம்",
"பார்வையாளர்கள்"
      ],
      label: "தினசரி பணிகள்",
      value: [
"செயல்படும் தேதி",
"ஒரு வருடம்",
"தயவுசெய்து முதலில் உள்நுழையவும்",
"இன்டர்ன்ஷிப் செல்லுபடியாகும் காலம்",
"டெபாசிட் ரிட்டர்ன் கவுண்டவுன்",
"லெவல் விஐபி செல்லுபடியாகும் கவுண்டவுன்"
      ],
    },
    list: {
      label: "தினசரி ஆர்டர்:{number}",
      button: "இப்போதே சேருங்கள்",
      text: [
"தினசரி லாபம்",
"மாதாந்திர வருமானம்",
"ஆட்சேர்ப்பு வெகுமதி: அனைவருக்கும்",
"இலவசம்",
"ஆர்டருக்கு",
"மதிப்பீட்டு வருமானம்",
"பயனுள்ள வருமானம்",
"காலாவதி தேதி",
"ஆண்டு",
"நாள்",
"செல்லுபடியாகும் காலம்"
      ],
    },
    dialog: [
"நீங்கள் {name} ஆக மாறுவதற்கு {currency} {amount} செலவழிக்கிறீர்களா?",
"நீங்கள் தற்போது {currname} ஆக இருக்கிறீர்கள், மேலும் {name} ஆக இருக்க முடியாது",
"{name} ஐ புதுப்பிக்க {currency} {amount} செலவழிக்கிறீர்களா?",
    ],
    index: ["ரத்துசெய்", "உறுதிப்படுத்து"],
    desc: [
'{level} சலுகைகள்',
'அடிப்படை வருமானம்',
'நேரம்',
'டெலிவரி எண்ணிக்கை',
'வருமானம்',
'தினசரி',
'மாதாந்திர',
'ஆண்டுதோறும்',
'பணியமர்த்தல் வருமானம்',//8
'துணை நிலை',
'ஆட்சேர்ப்பு கமிஷன் விகிதம்',
'ஆட்சேர்ப்பு போனஸ்',
'நிலை 1 துணை',
"நிலை 2 துணை",
"நிலை 3 துணை",
'ஒற்றை நாள் டெலிவரி தள்ளுபடி',
'துணை நிலை',
'துணை விநியோக தள்ளுபடி விகிதம்',//17
'டெலிவரி தள்ளுபடி தொகை',
'நிலை 1 துணை',
'நிலை 2 துணை',
'நிலை 3 துணை',
'3 நாட்கள்',
'டெலிவரி யூனிட் விலை',
'நடைமுறை கால விவரங்கள்',//24
'பயிற்சி: கொள்முதல் தேவையில்லை, ஒரு நாளைக்கு 6 வேலைவாய்ப்புகள், ஒரு இடத்திற்கு 11 ரூபாய் கமிஷன், ஒரு இடத்திற்கு 66 ரூபாய் நாள். 3 நாட்களுக்கு இலவச சோதனை',
'பணி கமிஷனின் எடுத்துக்காட்டு:',
'<p>ஒரு நாளைக்கு 10,000 TJS மதிப்புள்ள சவாரி ஆர்டர்களை முடிக்கும் நிலை 1 துணை நிறுவனங்களுக்கு 300 TJS கமிஷன் கிடைக்கும்.</p><p>ஒரு நாளைக்கு 10,000 TJS மதிப்புள்ள சவாரி ஆர்டர்களை முடிக்கும் நிலை 2 துணை நிறுவனங்களுக்கு 200 TJS கமிஷன் கிடைக்கும்.</p><p>ஒரு நாளைக்கு 10,000 TJS மதிப்புள்ள சவாரி ஆர்டர்களை முடிக்கும் நிலை 3 துணை நிறுவனங்களுக்கு 100 TJS கமிஷன் கிடைக்கும்.</p><p>ஒரு நாளைக்கு 10,000 TJS மதிப்புள்ள சவாரி ஆர்டர்களை முடிக்கும் நிலை 3 துணை நிறுவனங்களுக்கு 100 TJS கமிஷன் கிடைக்கும். </p>',
'பரிந்துரை போனஸ் விளக்கம்:',
'<p>(நிலை 1 துணை) நீங்கள் நேரடியாக A ஐ சேர அழைக்கிறீர்கள், A உங்கள் நிலை 1 துணை.</p><p>(நிலை 2 துணை) A B ஐ சேர அழைக்கிறார், B உங்கள் நிலை 2 துணை.</p><p>(நிலை 3 துணை) B C ஐ சேர அழைக்கிறார், C உங்கள் நிலை 3 துணை.</p><p>குறிப்பு: பரிந்துரை போனஸை தனிநபரின் தற்போதைய மட்டத்தின் மிக உயர்ந்த போனஸுக்கு மட்டுமே கோர முடியும்.</p>',
    ]
  },
  charitable: [
    'SGM உலகளாவிய தளம்',
    'டிஜிட்டல் மார்க்கெட்டிங் மாற்றத்தை ஆழப்படுத்துதல், மத்திய ஆசியாவில் இணக்கத்திற்கு உதவுதல் மற்றும் உயர்தர குழுவுடன் ஒன்றிணைந்து நிதி சுதந்திரத்தை உருவாக்குதல்.',
    'கிக் டிஜிட்டல் பொருளாதாரம் மற்றும் உலகளாவிய கூட்டு மூல தளம் கட்டமைப்பு ஈவுத்தொகை காலத்திற்குள் நுழைகின்றன. வளர்ந்து வரும் சந்தைகளில், குறிப்பாக மத்திய ஆசியாவில் (தஜிகிஸ்தான் முக்கிய பிராந்தியமாக), குறைந்தபட்ச நுழைவுத் தடைகள் மற்றும் அதிக வருவாயுடன் பல்வேறு ஆன்லைன் வேலைவாய்ப்புக்கு பெரிய பணித்திறன் கொண்ட மக்களிடமிருந்து வெடித்தெழும் தேவை உள்ளது.',
    '"தனிப்பட்ட நெட்வொர்க் மதிப்பு மீட்பு" மற்றும் "டிஜிட்டல் பணி விநியோகம்" ஆகிய தனித்துவமான தொழில்நுட்பங்கள் மூலம், ஒவ்வொரு நபரின் ஓய்வு நேரத்தையும் நிலையான பொருளாதார சொத்துக்களாக மாற்றுகிறோம் மற்றும் பத்தாயிரக்கணக்கான குடும்பங்கள் தங்கள் வாழ்க்கை நிலைமைகளில் ஒட்டுமொத்த முன்னேற்றங்களை அடைய உதவுகிறோம்.',
    'சமூக தொண்டு முயற்சிகளில் தீவிரமாக பங்கேற்கவும், நகரத்தின் ஒவ்வொரு மூலையிலும் அன்பும் பசுமையும் செழிக்கட்டும் என்று நாங்கள் உங்களை ஊக்குவிக்கிறோம்..',
    'அதிகாரப்பூர்வ வணிக வெள்ளைத் தாள் v2.7.1'
  ],
  lucky: {
  	default:[
"அதிர்ஷ்ட மிதி",
"மீதமுள்ள டிராக்களின் எண்ணிக்கை:",
"ராஃபிள் பதிவு",
"லாட்டரி விதிகள்",
"<p>நிறுவன நடவடிக்கைகளில் பங்கேற்று அதிர்ஷ்ட டிரா வாய்ப்புகளைப் பெறுங்கள்!</p>",
"வெற்றி பெறும் பயனர் பதிவு",
['வாழ்த்துக்கள்:{member}','பரிசுகளைப் பெறுங்கள் {profit}'],
"வாழ்த்துக்கள்,பரிசுகளைப் பெறுங்கள்",
"மூடு",
"உங்கள் டிரா நேரங்கள் பயன்படுத்தப்பட்டன",
"செல்லுபடியாகும் வரை"
  	],
    scattered:[
'டிராக்களின் எண்ணிக்கை',
'ரைடு',
'<p>1.டிராக்களின் எண்ணிக்கை நிறுவனத்தின் செயல்பாடுகள் மூலம் பெறப்படுகிறது!</p><p>2.ஒவ்வொரு டிராவும் 1 டிராவைப் பயன்படுத்துகிறது!</p><p>3.பரிசை வென்ற பிறகு, உங்கள் தகவலைப் பதிவுசெய்து அதைப் பெற ஆட்சேர்ப்பு மேலாளரைத் தொடர்பு கொள்ளவும்!</p>',
'நினைவூட்டல்',
'முக்கியமான நினைவூட்டல்கள்',
'டிரா தகுதி',
'நிறுவன நடவடிக்கைகள் மூலம் டிரா வாய்ப்புகளைப் பெறுதல்',
'டிரா விதிகள்',
'ஒரு முயற்சிக்கு 1 டிரா பயன்படுத்தப்படுகிறது',
'பரிசு மீட்பு',
'பரிசுகளுக்கு ஆட்சேர்ப்பு மேலாளரைத் தொடர்பு கொள்ளவும்'
    ],
	prizeList:[
		'லக்கி பெடல் பரிசுத் தொகுப்பு',
		'TJS52 ரொக்கம்',
		'உடனடியாக திரும்பப் பெறுதல்',
		'TJS88 ரொக்கம்',
		'TJS205 ரொக்கம்',
		'TJS19,889 ரொக்கம்',
		'TJS236,666 ரொக்கம்',
		'ஆண்ட்ராய்டு போன்',
		'TJS8,000 மதிப்புடையது',
		'மேம்படுத்தல் வவுச்சர்',
		'TJS600 மதிப்பு',
		'இரட்டை ஆர்டர்கள்',
		'தினசரி',
		'SGM.s நிறுவனத்தின் பிரத்யேக பவர் பேங்க்',
		'TJS1,000 மதிப்புடையது',
		'மெக்கானிக்கல் பைக்',
		'TJS3,000 மதிப்புடையது',
		'இ-மொபெட்',
		'TJS80,000 மதிப்புடையது',
		'ஐபோன் 17',
		'TJS160,000 மதிப்புடையது'
	],
  },
  moments:[
	  'தினசரி புதுப்பிப்புகள்',
	  'SGM.s ஊழியர்கள் பைக் பயன்படுத்தல் வருவாய், தொண்டு நடவடிக்கைகள் மற்றும் அற்புதமான தருணங்களைப் பகிர்ந்து கொள்வதற்கான அதிகாரப்பூர்வ தளம். ரொக்கப் பரிசு டிராக்களில் (1-200,000 ரூ.) பங்கேற்க தொடர்ந்து 3 நாட்களுக்கு தினமும் புதுப்பிக்கவும். அன்பைப் பரப்புவதிலும் ஒவ்வொரு சவாரியையும் மிகவும் மதிப்புமிக்கதாக மாற்றுவதிலும் உங்கள் அணியினருடன் சேருங்கள்.!'
  ],
  userLc:{
  	default:[
"சைக்கிள் ஓட்டுதல் செல்வம்",
"பதிவுகள்",
"தொகை",
"சேமிப்பு காலம்",
"வைப்புத் தொகை",
"வைப்புத் தொகையை உள்ளிடவும்",
"வருவாய்",
"சமர்ப்பி",//7
"தயவுசெய்து முதலில் தயாரிப்பைத் தேர்ந்தெடுக்கவும்",
"தயவுசெய்து தகவலைத் தேர்ந்தெடுக்கவும்",
"லாபம்",
"நாள்",
"தரவு இல்லை",
"கொள்முதல் நேரம்",
"நிலை",
"முடிவு நேரம்",
"இருப்பு",
"இன்றைய வருவாய்",
"ஒரு கிளிக்கில் வாங்குதல்"//18
  	],
    tabs: [
"தயாரிப்பு பட்டியல்",
"சேமிப்பு பதிவு"
     ],
    tips:'<p>VOISP "Wealth Enhance" என்பது நிறுவனத்தின் அனைத்து M-நிலை ஊழியர்களுக்கும் அவர்களின் வருமானத்தை அதிகரிக்க கூடுதல் வழிகளை வழங்குவதற்கான ஒரு வழியாகும். முதலீட்டுத் திட்டங்கள் என்பது PAGE, வங்கிகள், சொத்து மேலாண்மை நிறுவனங்கள் போன்றவற்றால் கூட்டாகத் தொடங்கப்படும் நிதி முதலீட்டுத் திட்டங்களாகும்!</p><p>குறுகிய கால முதலீடு: நிலையான வருமானம், நெகிழ்வான சுழற்சி தேர்வு! குறுகிய கால செயலற்ற நிதிகள் முதலீட்டின் மூலம் கூடுதல் வருமானத்தைக் கொண்டு வரலாம்! நீண்ட கால முதலீடு: அதிக வருமானம், நல்ல வழக்கமான முதலீட்டு சேமிப்பை வளர்த்துக் கொள்ளுங்கள், அதிக வருமானத்தைப் பெறுங்கள், மேலும் குவிப்பு மூலம் உங்கள் கனவுகளை நனவாக்குங்கள்.!</p>'
  },
  newlist: {
    text: [
"பதிவுகள் இல்லை",
"எதிர்பார்க்கப்பட்ட வருமானம்",
"முடிவுகள்",
"வாங்கும் நேரம்",
"நிலை",
"காலத்தின் முடிவு"
    ],
    placeholder: [
"இனி தரவு இல்லை",
"தரவு இல்லை"
    ],
    i18n: [
     "கொள்முதல் வரலாறு",
    ],
	title:[
		"Cycling Wealth பசுமை சேமிப்பு திட்டம் — SGM.s நிறுவனத்தின் நிரந்தர ஊழியர்களுக்காக சிறப்பாக வடிவமைக்கப்பட்ட தனிப்பட்ட நன்மை!",
		"RBI போன்ற நம்பகமான நிதி நிறுவனங்களால் ஒப்புதல் பெற்றதும், கண்காணிக்கப்படுவதும் ஆகும்; உங்கள் நிதிகள் 100% பாதுகாப்பாக உள்ளன. முன்னணி வங்கிகளுடன் இணைந்து, SGM பல்வேறு சேமிப்பு திட்டங்களை வழங்குகிறது, இவை நெகிழ்வான கால அளவுகளும், பலவகை வருமானங்களும் கொண்டவை, உங்கள் நிதி இலக்குகளுக்கு ஏற்ப.",
		"நீங்கள் சைக்கிள் விநியோகத்தில் தீவிரமாக ஈடுபடுவதையும், குறைந்த கார்பன் பயணத்தை ஏற்குவதையும் மட்டுமல்லாமல், உங்கள் எதிர்காலத்திற்காக நிதி திட்டமிடுவதையும் SGM ஊக்குவிக்கிறது. பசுமை செல்வத்தின் புதிய அத்தியாயத்தை தொடங்க SGM உங்களுடன் கைகோர்க்கிறது!"
	]
  },
  product: {
    default: [
"ஊக்குவிப்பு கணக்கு இருப்பு",
"ஆரம்ப சேமிப்புத் தொகை",
"அதிகபட்ச சேமிப்புத் தொகை",
"சுழற்சி",
"தினசரி வட்டி விகிதம்",
"அதிகபட்சம்",
"திட்ட விதிகள்",
"திட்டத் தொகை",
"கட்டண முறை",
"ஆரம்ப சேமிப்புத் தொகை",
"தினசரி லாபம்",
"வெளியீட்டு சுழற்சி",
"மதிப்பிடப்பட்ட வருமானம்"
    ],
    investRange: "முதலீட்டு தொகை வரம்பு",
    placeholder: [
"முதிர்ச்சியின் போது அசல் மற்றும் வருமானத்தைத் திருப்பித் தரவும் (விடுமுறை நாட்களில் சாதாரணமானது)",
", 24 மணி நேரத்திற்குள் தானியங்கி தீர்வு",
"{str} = மொத்த வருமானம் {income} {currency} + அசல் {money} {currency} = மொத்த அசல் மற்றும் வட்டி {total} {currency}",
"பாதுகாப்பு கடவுச்சொல்"
    ]
  },
  user: {
    vipl:"கூட்டாளர் நிலை",
    hello:"மீண்டும் வருக.",
    default: [
"எனது மேலதிகாரி",
"கணக்கு",
"அழைப்பு குறியீடு",
"உள்நுழைவிலிருந்து வெளியேறு",
"இருப்பு",
"தங்கம்",
"எனது பணப்பை",
"முத்திரை",
"கட்டுப்பாடு",
"நல்லது",
"சிறந்தது",
"'படித்தல் உதவியாளரை' செயல்படுத்து",
"பணியமர்த்தல் மேலாளரைத் தொடர்புகொள்",
"வங்கி கட்டணம்"
    ],
    myEarnings: {
            grid: ["இருப்பு","நேற்றைய வருவாய்","இன்றைய வருவாய்","இந்த வார வருவாய்","இந்த மாத வருவாய்","கடந்த மாத வருவாய்","மொத்த வருவாய்","இன்றே பணியை முடிக்கவும்(PCE)","இன்றைய மீதமுள்ள பணிகள்(PCE)","இன்றைய கமிஷன்","டெலிவரி தள்ளுபடி","பரிந்துரை தள்ளுபடி"]
        },
    grid: [
"இருப்பு",
"நேற்றைய வருவாய்",
"இன்றைய வருவாய்",
"இந்த வார வருவாய்",
"இந்த மாத வருவாய்",
"கடந்த மாத வருவாய்",
"மொத்த வருவாய்",
"இன்றே பணியை முடிக்கவும் (PCE)",
"இன்றைய மீதமுள்ள பணிகள் (PCE)",
"இன்றைய கமிஷன்",
"இன்றைய தள்ளுபடி"
    ],
    menu: [
"பணிப் பதிவுகள்",
"தணிக்கைப் பணி",
"வெளியீட்டு மேலாண்மை",
"தனிப்பட்ட தகவல்",//3
"கணக்கு பிணைப்பு",
"தினசரி அறிக்கை",
"கணக்கியல் பதிவுகள்",//6
"பகிரப்பட்ட அழைப்பு",
"குழு அறிக்கைகள்",//8
"உதவி கையேடு",//9
"கிரெடிட் ஸ்கோர்",//10
"APP பதிவிறக்கம்",//11
"அதிர்ஷ்ட மிதி",//12
"சைக்கிளிங் செல்வம்",
"படித்தல் உதவியாளர்",
"கார்ப்பரேட் கலாச்சாரம்",
"வீடியோ அறிவுறுத்தல்",
"சிறந்த குழு",
"சைக்கிளிங் செல்வம்",
"SGM.s ஐப் பின்பற்றவும்",
"வளர்ச்சி வெகுமதிகள்",
"சைக்கிளிங் குறியீடு",
"செயல்கள் மிதி",
"SGM சான்றிதழ்"
    ],
	positions:[
"எனது நிலை",
"தற்போதைய நிலை",
"அடுத்த நிலை",
"நேரடியாக இணைக்கப்பட்ட M-நிலை உறுப்பினர்",
"நிலை 3 குழு M உறுப்பினர்",
      "நிலை 3 அணி (எண்ணிக்கை {post})",
"உங்கள் பதவியை மேம்படுத்த பணியமர்த்தல் மேலாளரைத் தொடர்பு கொள்ள அனைத்துத் தேவைகளையும் பூர்த்தி செய்யுங்கள்!",
"பதவி விளக்கம்",
"பதவிக்கு விண்ணப்பிக்கவும்",
"பதவி தகவல்"
	],
	office:[
"எனது பணித் தகவல்",
"வேலை ஊக்குவிப்பு விவரங்கள்",
"SGM.s பணி விவரம்",
"கார்ப்பரேட் பதவி",
"வேலை ஊக்குவிப்பு",
"உங்கள் விண்ணப்பத்தைச் சமர்ப்பிக்கவும்",
"பதவி உயர்வு முன்னேற்றம்",
"குறைந்தபட்சம் ",
"நிபந்தனைகள் பூர்த்தி செய்யப்படவில்லை",//8
"மூன்று நிலை குழுவில் (1/2/3) உறுப்பினர்கள் ({name}) ஆக வேண்டும்",
"அணியில் ",
" உறுப்பினர்களுக்கு மேல் இருக்க வேண்டும்",
"பெறப்பட்டது"//12
	],
	current:[
"தற்போதைய பதவிகள்",
"VIP மொத்த உறுப்பினர்கள்"
	],
	subordinate:[
"1-நிலை",
"2-நிலை",
"3-நிலை",
"உறுப்பினர் பட்டியல்",
"மொத்த நபர்கள்",
"மொத்த வருவாய்",
"திரும்பப் பெறும் தொகை",
"குழு வருமானம்",
"உறுப்பினர் பட்டியல்",
"பயனர்",
"நிலை",
"சேரும் நேரம்",
"சோதனை காலம்"
	],
	follow:[
"SGM.s அதிகாரப்பூர்வ சேனல்",
"சமீபத்திய SGM.s தகவல்களைப் பற்றி மேலும் அறிய சேனலைப் பின்தொடருங்கள்!"
	]
  },
  userInfo: {
    default: [
"தனிப்பட்ட தகவல்",
"தலைமை உருவப்படம்",
"மொபைல் எண்",
"வங்கி கணக்கைச் சேர்",
"அலிபே",
"உண்மையான பெயர்",
"உள்நுழைவு கடவுச்சொல்",
"நிதி கடவுச்சொல்",
"அமைப்புகளைக் கிளிக் செய்யவும்",
"தலைமை உருவப்படத்தை மாற்று",
"உள்நுழைவு கடவுச்சொல்லை மாற்று",
"நிதி கடவுச்சொல்லை மாற்று",
"சமர்ப்பி",

"தற்காலிக சேமிப்பை காலி செய்",
"வெளியேறு"
    ],
    label: [
"அசல் உள்நுழைவு கடவுச்சொல்",
"புதிய உள்நுழைவு கடவுச்சொல்",
"கடவுச்சொற்களை உறுதிப்படுத்துதல்",
"அசல் பணக் குறியீடு",
"புதிய பணக் குறியீடு",
"கடவுச்சொல்லை உறுதிப்படுத்து"
    ],
    placeholder: [
"தயவுசெய்து அசல் உள்நுழைவு கடவுச்சொல்லை உள்ளிடவும்",
"தயவுசெய்து புதிய உள்நுழைவு கடவுச்சொல்லை உள்ளிடவும்",
"தயவுசெய்து உள்நுழைவு கடவுச்சொல்லை உறுதிப்படுத்தவும்",
"தயவுசெய்து அசல் நிதி கடவுச்சொல்லை உள்ளிடவும்",
"தயவுசெய்து புதிய நிதி கடவுச்சொல்லை உள்ளிடவும்",
"தயவுசெய்து நிதி கடவுச்சொல்லை உறுதிப்படுத்தவும்"
    ]
  },
  userSet: {
    default: [
"உண்மையான பெயர் சான்றிதழ்",
"விரிவான தகவல்",
"அலிபேயை பிணை",
"சமர்ப்பி"
    ],
    label: [
"உண்மையான பெயர்",
"QQ",
"அலிபே கணக்கு",
"அலிபே பெயர்"
    ],
    placeholder: [
"தயவுசெய்து உண்மையான பெயரை உள்ளிடவும் (ரொக்கம் எடுக்க எனது பெயர் பயன்படுத்தப்படுகிறது)",
"QQ எண்ணை உள்ளிடவும்",
"தயவுசெய்து Alipay கணக்கை உள்ளிடவும்",
"தயவுசெய்து Alipay பெயரை உள்ளிடவும்"
    ],
    tips: "நினைவூட்டல்: பிணைக்கப்பட்ட வங்கி அட்டையை மாற்ற முடியாது, அது உங்கள் பணத்தை எடுக்கப் பயன்படுகிறது."
  },
  bindAccount: {
    default: [
"கணக்கை பிணை",
"டுடோரியலைப் பார்க்கவும்",
"சமர்ப்பி"
    ],
    tabs: [
"கணக்கு",
"கணக்கு",
"கணக்கு"
    ],
    label: [
"வழிமுறைகள்",
"ஸ்கிரீன்ஷாட்டைச் சேர்",
"கணக்கு"
    ],
    placeholder: "உங்கள் {account} கணக்கை உள்ளிடவும்."
  },
  bankCard: {
    default: [
"வங்கி அட்டையை பிணை",
"இப்போது அங்கீகரிக்கவும்",
"சமர்ப்பிக்கிறது...",
"இப்போது சேர்",
"வங்கி அட்டையைச் சேர்"
    ],
    tips: [
"வங்கி அட்டையைச் சேர்ப்பதற்கு முன் உண்மையான பெயர் அங்கீகாரத்தை முடிக்கவும்",
"உங்கள் வங்கி அட்டையில் உள்ள கணக்குப் பெயர் நீங்கள் அங்கீகரித்த உண்மையான பெயருடன் ஒத்துப்போக வேண்டும், இல்லையெனில் நீங்கள் வெற்றிகரமாக பணத்தை எடுக்க முடியாது."
    ],
    label: [
"பெயர்",
"வங்கி பெயர்",
"வங்கி கணக்கு எண்",
"கிளை குறியீடு",
"IFSC"
    ],
    placeholder: [
"தயவுசெய்து வங்கிப் பெயரைத் தேர்ந்தெடுக்கவும்",
"தயவுசெய்து வங்கிக் கணக்கு எண்ணை உள்ளிடவும்",
"கிளைக் குறியீட்டை உள்ளிடவும்",
"உறுதிப்படுத்தவும்",
"ரத்துசெய்",
"IFSC ஐ உள்ளிடவும்"
    ]
  },
  wallet: {
    default: [
"எனது பணப்பை",
"ரீசார்ஜ்",
"திரும்பப் பெறுதல்",
"மீட்டெடுப்பு பதிவு",
"திரும்பப் பெறுதல் பதிவு",
"R",
"W",
"₽ ரீசார்ஜ்"
    ],
    label: [
"திரும்பப் பெறும் முறை",
"திரும்பப் பெறும் தொகை",
"நிதி கடவுச்சொல்",
"சமர்ப்பி",
"தொலைபேசி எண்",
"மின்னஞ்சல்",
"IFSC",
"கட்டண முறை",
"வரிவிதிப்பு",
"உண்மையான தொகை பெறப்பட்டது"
    ],
    placeholder: [
"திரும்பப் பெறும் முறையைத் தேர்ந்தெடுக்கவும்",
"திரும்பப் பெறும் தொகையை உள்ளிடவும்",
"தயவுசெய்து நிதி கடவுச்சொல்லை உள்ளிடவும்",
"திரும்பப் பெறும் முறையைத் தேர்ந்தெடுக்கவும்",
"தயவுசெய்து பணம் பெறுபவரின் மொபைல் தொலைபேசி எண்ணை உள்ளிடவும்",
"தயவுசெய்து பணம் பெறுபவரின் மின்னஞ்சல் முகவரியை உள்ளிடவும்",
"தயவுசெய்து பணம் பெறுபவரின் IFSC ஐ உள்ளிடவும்",
"தயவுசெய்து பணம் செலுத்துபவரின் கட்டண முறையைத் தேர்ந்தெடுக்கவும்"
    ],
    msg: [
"நீங்கள் இன்னும் நிதி கடவுச்சொல்லை அமைக்கவில்லை, முதலில் ஒன்றை அமைக்கவும்",
"உங்கள் வங்கி அட்டையை இன்னும் இணைக்கவில்லை, முதலில் அதை இணைக்கவும்",
"<p>திரும்பப் பெறும் நேரம்:</p><p>திங்கள்: M9</p><p>செவ்வாய்: M8</p><p>புதன்: M6/M7</p><p>வியாழன்: M3/M4/M5</p><p>வெள்ளி: M1/M2</p><p>(பயிற்சியாளர்கள் திங்கள் முதல் ஞாயிறு வரை)</p><p>காலை 9 மணி முதல் மாலை 6 மணி வரை</p>"
    ]
  },
  recharge: {
    default: [
"ரீசார்ஜ்",
"ரீசார்ஜ் விவரங்கள்",
"ரீசார்ஜ் பதிவு",
"கிடைக்கக்கூடிய இருப்பு {money}, தயவுசெய்து ரீசார்ஜ் முறையைத் தேர்வு செய்யவும்",
"ஒற்றை குறைந்தபட்ச தொகை {currency} {min}, அதிகபட்சம் {currency} {max}, கையாளுதல் கட்டணம் {fee}%",
"சமர்ப்பித்தல்...",
"இப்போது ரீசார்ஜ்",
"திருப்பி அனுப்புதல்",
"ஏற்றுகிறது...",
"ஒற்றை குறைந்தபட்ச தொகை ${min}, அதிகபட்சம் ${max}, கையாளுதல் கட்டணம் {fee}%"
    ],
    label: [
"ரீசார்ஜ் தொகை",
"ரீசார்ஜ் சேனல்",
"பரிமாற்றத்தின் பெயர்",
"பணம் செலுத்துபவரின் பெயர்",
"பணம் செலுத்துபவரின் மொபைல் போன்",
"பணம் செலுத்துபவரின் UPI கணக்கு",
"பணம் செலுத்துபவரின் மின்னஞ்சல்",
"பரிவர்த்தனை ஆர்டர்"
    ],
    placeholder: [
"ரீசார்ஜ் தொகையை உள்ளிடவும்",
"ரீசார்ஜ் சேனலைத் தேர்ந்தெடுக்கவும்",
"பரிமாற்றத்தின் பெயரை உள்ளிடவும்",
"ஒற்றை குறைந்தபட்ச தொகை {currency} {min}",
"ஒற்றை அதிகபட்ச தொகை {currency} {max}",
"பரிமாற்றம் செய்பவரின் பெயரை உள்ளிடவும்",
"பரிமாற்றம் செய்பவரின் மொபைல் எண்ணை உள்ளிடவும்",
"பரிமாற்றம் செய்பவரின் UPI கணக்கை உள்ளிடவும்",
"பரிமாற்றத்தின் ஸ்கிரீன்ஷாட்டை பதிவேற்றவும்",
"பரிவர்த்தனை ஆர்டர் எண்ணை உள்ளிடவும்"
    ],
    info: [
"ரீசார்ஜ் தொகை",
"ஆர்டர் எண்",
"வங்கி",
"கணக்கு எண்",
"பெயர்",
"நகல்",
"{type} பரிமாற்றம்",
"பரிமாற்ற ஸ்கிரீன்ஷாட்",
"சமர்ப்பி",
"IFSC குறியீடு",
"கணக்கு வகை",
"செயலாக்க வழிமுறைகள்"
    ],
    tips: [
"நிதிச் சரிபார்ப்பில் தாமதத்தைத் தவிர்க்க, பொருந்தக்கூடிய தொகையை மாற்ற பின்வரும் முறையைத் தேர்ந்தெடுக்கவும்.<br>பரிமாற்றத்திற்குப் பிறகு, சரிபார்ப்புச் சான்றிதழாக பரிமாற்ற ஸ்கிரீன்ஷாட்டை பதிவேற்றவும்",
"நண்பர்களைச் சேர்க்க வேண்டிய அவசியமில்லை, எனக்குப் பணத்தை மாற்ற QR குறியீட்டை ஸ்கேன் செய்யவும்",
"கீழே உள்ள தகவலின்படி பரிமாற்றத்தை முடிக்கவும்",
"குறிப்பு: வெற்றிகரமான கட்டணத்திற்குப் பிறகு, உங்கள் உறுப்பினர் கணக்கு எண், ரீசார்ஜ் தொகை, ஆர்டர் எண், வைப்புத்தொகையாளர் கணக்கு எண், ரீசார்ஜ் நேரம், நிதித் துறை உங்களுக்காக சரியான நேரத்தில் நிதியைச் சேர்க்க வசதியானது ஆகியவற்றை வழங்க ஆன்லைன் சேவையைத் தொடர்பு கொள்ளவும்.",
"குறிப்பு: ஒவ்வொரு பரிமாற்றத்திற்கும் ஒரு கட்டணத்தைச் சமர்ப்பிக்கவும்",
"பரிமாற்றத்திற்குப் பிறகு, பரிமாற்ற ஸ்கிரீன்ஷாட்டை சரிபார்ப்புச் சான்றிதழாக பதிவேற்றவும்",
"குறிப்பு: பணம் செலுத்துதல் வெற்றிகரமாக முடிந்த பிறகு, வெற்றிகரமான பரிவர்த்தனையின் படத்தைப் பதிவேற்றவும்",
"<p>ரீசார்ஜ் நினைவூட்டல்: ரீசார்ஜ் செய்வதற்கு முன் படிக்கவும்.</p><p>1: சமீபத்திய ரீசார்ஜ் கணக்கின்படி பணம் செலுத்தவும்.</p><p>2: கட்டண செல்லுபடியாகும் காலம் 10 நிமிடங்கள். 10 நிமிடங்களுக்குள் கட்டணத்தை முடிக்கவும். 10 நிமிடங்களுக்குப் பிறகு பணம் செலுத்தப்படாவிட்டால், பெறும் கணக்கு தவறானது. பணம் செலுத்துவதற்கு சமீபத்திய ரீசார்ஜ் கணக்கை மீண்டும் பெறவும்.</p><p>3: பரிமாற்றத் தொகை நீங்கள் சமர்ப்பித்த தொகையுடன் ஒத்துப்போக வேண்டும்.</p><p>4: பணம் செலுத்தத் தவறினால், முந்தைய பெறும் கணக்கைச் சேமிக்க வேண்டாம். சமீபத்திய கணக்கைப் பெற ரீசார்ஜ் ஆர்டரை மீண்டும் சமர்ப்பிக்கவும், இல்லையெனில் உங்கள் கட்டணம் செல்லாததாகக் கருதப்படும்.</p><p>5: பணம் செலுத்துதல் வெற்றிகரமாக இருந்தால், நிதித் துறையால் சரியான நேரத்தில் சரிபார்ப்பை எளிதாக்க, தேவையான UTR ஐச் சமர்ப்பிக்கவும்.</p>"
    ],
    minPayHint: "குறைந்தபட்ச கட்டண தொகை {min}TJS"
  },
  postTask:[
"தலைப்பு",
"படத்தைத் தேர்ந்தெடுக்கவும்",
"வழங்கு",
"பணிக்கு ஒரு தலைப்பை உள்ளிடவும்"
  ],
  task: {
    default: [
"டெலிவரி பட்டியல்",
"பணி தேவைகள்",
"உருவாக்கு",
"தணிக்கை",
"இணைப்பைத் திற",
"இணைப்பை நகலெடுக்கவும்",
"அலகு விலை",
"சமர்ப்பி",
"தள்ளுபடி",
"சேவையைத் தொடங்கு",
"செயல்பாட்டில் உள்ளது",
"பணியமர்த்தலைத் தொடங்கு"
    ],
    tabs: [
"செய்கிறது",
"தணிக்கை",
"முடிந்தது",
"தோல்வியடைந்தது",
"தீங்கு விளைவித்தது",
"கைவிடப்பட்டது"
    ],
    msg: "இன்றைய பணி முடிந்தது.",
    msgSc: "வெற்றிகரமாகப் பெறப்பட்டது",
    msgTime: "கவுண்டவுன் முடிந்ததும், பணி தானாகவே முடிக்கப்படும், மேலும் அதை முன்கூட்டியே மூடுவது செல்லாது.!",
    info: [
"பணி விவரங்கள்",
"பணி தலைப்பு",
"பணி நன்மைகள்",
"பணி விளக்கம்",
"பதிவேற்றத் தேவைகள்",
"மாதிரியைச் சமர்ப்பி",
"பயனர் மாதிரியைச் சமர்ப்பிக்கவில்லை",
"தணிக்கை குறிப்புகள்",
"தணிக்கை தேதி",
"தேவை பக்கம்",
"வெளியீடு",
"நகல்",
"தாவிச் செல்லவும்",
"பணி படிகள்",
"படி {குறியீடு}",
"தணிக்கை மாதிரி",
"தணிக்கை மாதிரி இல்லை",
"தரவு ஏற்றுதல்...",
"பணியை விட்டுவிடு",
"முடிக்கப்பட்ட பணியைச் சமர்ப்பி",
"உள்ளடக்கத்தை வெளியிடு"
    ],
    index: [
"தற்போதைய நிலை",
"உங்கள் தற்போதைய மதிப்பீடு <i style=\"color:#1989fa\">{currVip}</i><br>தற்போதைய> நிலை பணியை மட்டுமே கோர முடியும்<br>நீங்கள் <i style=\"color:#dd6161\">{vip}</i> மட்டத்தில் சேர விரும்புகிறீர்களா",
"இப்போது சேருங்கள்",
"பணி வகையைத் தேர்ந்தெடுக்கவும்",
"ரத்துசெய்",

      "மீதமுள்ளவை",
      "இலவச டெலிவரி",
      "விரைவில் வருகிறது"
    ],
    list: [
"பணிப் பட்டியல்",
"தேவை பக்கம்",
"மீதமுள்ளவை",
"கோரிக்கை",
"பெறுகிறது"
    ],
    show: [
"பணி விவரங்கள்",
"கொள்முதல் நேரம்",
"டெலிவரி நிலை",
"வாடகை விலை",
"டெலிவரி நேரம்",
"பெறுவதற்கான கவுண்டவுன்",
"சேவையைத் தொடங்கு",
"குறியீடு",
"தெரியாது"
    ]
  },
  postRecord: [
"தினசரி புதுப்பிப்புகள்",
"வெளியீடு",
"மொத்தம்",
"முடிந்தது",

"காலக்கெடு",

"தணிக்கை",

"நீக்குதல்",

"ஆசிரியர்கள்",

"தினசரி புதுப்பிப்புகள்",
"பெறப்பட்டது",
"SGM அறிவிப்பு மையம்",
"தகவல் மையம்"
  ],
  dayReport: [
"தினசரி அறிக்கை",
"மொத்த வருவாய்",
"எனது கமிஷன்",
"எனது கமிஷன் சலுகைகள்",
"கீழ் பணியாளர்களால் முடிக்கப்பட்ட டெலிவரி",
"கீழ் பணி சலுகைகள்",
"PCE",
"கடந்த 30 நாட்கள்",
"அளவு",
"டெலிவரி",
"கீழ் பணியாளர்",
"நுகர்வு",
"தேதி"
  ],
  fundRecord: {
    default: [
"செலவு பதிவுகள்",
"ரீசார்ஜ் பதிவு",
"வருவாய் பதிவுகள்",
"R",
"I",
"E",
"திரும்பப் பெறுதல் பதிவுகள்",
    ],
    tabs: [
"வருவாய்",
"செலவு",
"ரீசார்ஜ்",
"திரும்பப் பெறுதல்"
    ],
	state: [
		'அனைத்தும்',
		'ரீசார்ஜ்',	//1 recharge
		'திரும்பப் பெறுதல்',	//2 withdrawal
		'பணியை இடுகையிடு',	//3 task
		'பிளாட் பம்ப்',	//4 pump
		'தள்ளுபடி',	//5 rebate
		'டெலிவரி முடிந்தது',	//6 commission
		'செயல்பாட்டு வெகுமதிகள்',	//7 regment
		'பரிந்துரை வெகுமதிகள்',	//8 spread
		'மேம்படுத்து',	//9 buymembers
		'பணியை ரத்துசெய்',	//10 revoke
		'முதலீட்டு வருமானம்',	//11 transfer_c
		'முதலீட்டிற்கு மாற்றுதல்',	//12 transfer_r
		'பிற வருவாய்', //13 其他
		'நன்கொடை அளியுங்கள்',	//14
		'சிவப்பு உறை',	//15
		'ஸ்மார்ட் ரோபோக்களை வாங்கவும்',//16
		'அதிர்ஷ்ட மிதி',//17
		'விஐபி கொள்முதல் பணத்தைத் திரும்பப் பெறுதல்',//18
	]
  },
  promote: [
	"உங்கள் சிறந்த நண்பர்",
	"{title} இல் சேர உங்களை அழைக்கவும்",
	"பரிந்துரை குறியீடு",
	"பரிந்துரை குறியீட்டை நகலெடுக்கவும்",
	"QR குறியீட்டை நகலெடுக்கவும்",
	"QR குறியீட்டைச் சேமி",
	"விளம்பர ஊக்கத்தொகைகள்",
	"போஸ்டரை வெற்றிகரமாக சேமிக்கவும்",//7
	"போஸ்டரைச் சேமிக்கத் தவறியது, இன்னும் சில முறை முயற்சிக்கவும் அல்லது ஸ்கிரீன்ஷாட்டைச் சேமிக்கவும்",
	"தயவுசெய்து ஸ்கிரீன்ஷாட்டை எடுக்கவும்",
	"விளம்பர சுவரொட்டியைச் சேமிக்கவும்",
	"விளம்பர சுவரொட்டியை உங்கள் தொலைபேசியில் சேமிக்கவும்<br>நீங்கள் தோல்வியுற்றால், இன்னும் சில முறை முயற்சிக்கவும் அல்லது ஸ்கிரீன்ஷாட்டைச் சேமிக்கவும்",
	"SGM.s VIP அதிகாரப்பூர்வ பயனர்கள் மட்டுமே நண்பர்களை சேர அழைக்க தகுதியுடையவர்கள்!",
	"பகிரப்பட்ட அழைப்பு",
	
	'<p>பகிர்வு விருது: புதிய பயனர்களை SGM.s-இல் அழைத்தால் பகிர்வு விருது கிடைக்கும்.</p><p>குழு கமிஷன்: உங்கள் கீழமை உறுப்பினர்களின் தினசரி சைக்கிள் செயல்பாடுகளிலிருந்து கமிஷன் பெறலாம்.</p><p>நிறுவன நிகழ்வுகள்: நிறுவனம் "லக்கி பெடல்", "சைக்கிளிங் கோடு", மற்றும் உடைமையான பரிசுகள் உள்ளிட்ட பல்வேறு பிரமோஷன்களை தவணையாக நடத்துகிறது.</p><p>தொகுக்கப்பட்ட விருதுகள்: ஒரு குறிப்பிட்ட எண்ணிக்கையிலான நண்பர்களை அழைத்தால், தளத்தின் முகப்புப் பக்கத்தில் பண விருது பெறலாம். அழைப்புகள் அதிகமாக இருந்தால், விருதும் அதிகமாகும்.</p><p>நிறுவன பதவிகள்: உங்கள் குழு ஒரு குறிப்பிட்ட அளவுக்கு சென்றவுடன், நீங்கள் நிறுவனத்தில் மேலும் பதவிகளுக்கு விண்ணப்பிக்கலாம் — தொடக்க நிலை, நடுநிலை, மூத்த நிலை மற்றும் மார்க்கெட்டிங் மேலாளர் போன்றவை — மேலும் மாத சம்பளமும் பெறலாம்.</p><p><ஒவ்வொரு சைக்கிள் வெளியீடும் ஒரு நிதி சுதந்திரத்தின் படியாகும்; ஒவ்வொரு சவாரியும் நகர மாசுபாட்டைக் குறைக்கும். SGM உங்கள் நிதி சுதந்திரம் மற்றும் பசுமை வாழ்க்கை இலக்குகளை அடைய உதவுகிறது.</p>',
	"குழுப் பகிர்வு பயணம்"
  ],
  teamReport: {
    default: [
"தேடல்",
"அணி இருப்பு",
"அணி சலுகைகள்",
"அணி ரீசார்ஜ்",
"அணி திரும்பப் பெறுதல்",
"முதல் கட்டணத்தின் எண்ணிக்கை",
"முதல் புஷ் எண்ணிக்கை",
"அணி அளவு",
"புதிய அணி",
"PCE",
"நான்",
"பயனர்",
"ரீசார்ஜ்",
"திரும்பப் பெறுதல்கள்",
"தள்ளுபடி",
"கமிஷன்",
"தேதியைத் தேர்ந்தெடுக்கவும்",
"தரம் இல்லை",
"திரும்பப் பெறுதல் தொகை",
"திரும்பப் பெறுதல் எண்",
"திரும்பப் பெறுதல் தள்ளுபடி",
"அணி திரும்பப் பெறுதல்களின் எண்ணிக்கை",//21
"அணி கூட்டாளர்",
"பரிந்துரைக்கப்பட்ட மொத்த வருமானம்",
"டெலிவரி தள்ளுபடிகளிலிருந்து மொத்த வருவாய்",
"நிலை 3 அணியின் மொத்த திரும்பப் பெறுதல்கள்",
"தரம்",
"பெற்றோர்",
"அழைக்கப்பட்டவர்கள்",
"பயனர் பட்டியல்",
"மொத்த பயனர்",
"குழுவைப் பார்க்க கிளிக் செய்யவும்"
    ],
    tabs: [
"குழு அறிக்கைகள்",
"எனது குழு"
    ],
    team: [
"நிலை 1",
"நிலை 2",
"நிலை 3"
    ],
    totalUser: "மொத்த பயனர்",
    clickViewTeam: "குழுவைப் பார்க்க கிளிக் செய்யவும்"
  },
  help: [
"உதவி கையேடு",
"கிடைக்கவில்லை"
  ],
  message:[
"செய்தியைக் காண்க",
"செய்தி இல்லை"
  ],
  credit: [
"கிரெடிட் ஸ்கோர்",
"கிரெடிட் குறிப்பு",
"கிரெடிட் பதிவுகள்",
"<p>ஆரம்ப கிரெடிட் ஸ்கோர் 60 புள்ளிகள்.</p><p>1: புள்ளிகள் 50 க்கும் குறைவாக இருந்தால், தினசரி டெலிவரி அளவு பாதியாகக் குறைக்கப்படும்.</p><p>2: மதிப்பெண் 30 புள்ளிகளுக்கு குறைவாக இருந்தால், தினசரி டெலிவரி வேலையை முடிக்க முடியாது.</p><p>3: மதிப்பெண் 10 புள்ளிகளுக்கு குறைவாக இருந்தால், நீங்கள் பணத்தை எடுக்க விண்ணப்பிக்க முடியாது.</p><p>புள்ளி வெகுமதி விதிகள்: பணி அளவை மேம்படுத்துவது 5 புள்ளிகளைச் சேர்க்கும், மேலும் கீழ்நிலை ஊழியர்களை (முறையான ஊழியர்கள்) ஆக அழைப்பது 1 புள்ளியைச் சேர்க்கும்.</p><p>எதிர்மறையான பணி மனப்பான்மை, சரியான நேரத்தில் டெலிவரி முடிக்கத் தவறியது மற்றும் நிறுவன விதிமுறைகளை மீறுவது ஒருவரின் கிரெடிட் ஸ்கோரைப் பாதிக்கும்.</p>",
"எனது கிரெடிட்",
"தற்போதைக்கு எந்த கிரெடிட் பதிவும் இல்லை"
  ],
  dialog: [
"உதவிக்குறிப்புகள்",
"உறுதிப்படுத்து",
"சமர்ப்பிக்கிறது...",
"நகல் வெற்றி பெற்றது",
"IOS சிஸ்டம் பதிப்பு குறைவாக உள்ளது மற்றும் ஆதரிக்கப்படவில்லை",
"பதிவு செய்கிறது...",
"தரவு ஏற்றப்படுகிறது..."
  ],
  lineList: [
"வரி தேர்வு",
"தற்போதைய வரி",
"வரி"
  ],
  serviceCenter: [
"வாடிக்கையாளர் சேவை",
"வணக்கம், பிரத்யேக வாடிக்கையாளர் சேவை",
"உங்களுக்கு சேவை செய்வதில் மகிழ்ச்சி.",
"சுய சேவை",
"ஆன்லைன் வாடிக்கையாளர் சேவை",
"வாடிக்கையாளர் சேவையை ரீசார்ஜ் செய்யுங்கள்",
"வரி வாடிக்கையாளர் சேவை"
  ],
  direct:[
'SGM.s',
'வளர்ச்சி போனஸ்',
'செயல்பாட்டு விளக்கம்',
'<p>VIP மட்டத்தில் சேர உறுப்பினர்களை நேரடியாக அழைத்த பிறகு, நீங்கள் நிபந்தனைகளை பூர்த்தி செய்தால் பண வெகுமதிகளைப் பெறலாம்!</p><p>உதாரணமாக: நீங்கள் 3 VIP-நிலை உறுப்பினர்களை ஒட்டுமொத்தமாக அழைத்தால், நீங்கள் நேரடியாக வெகுமதியைப் பெறலாம். அதைப் பெற்ற பிறகு, மற்ற இலக்குகளை அடையவும் தொடர்ந்து பெறவும்.</p><p>SGM பிரத்தியேக வளர்ச்சி வெகுமதி, ஒவ்வொரு பணியாளரும் ஒவ்வொரு விருதையும் ஒரு முறை மட்டுமே பெற முடியும்.</p>',
'துணை அதிகாரிகளின் எண்ணிக்கை',
'முடிக்கப்பட வேண்டும்',

'அழைப்புப் பலன்கள்',

'வெகுமதிகளைப் பெறுங்கள்',
'பெறப்பட்டது'
  ],
  activity:[
'பத்திரக் குறிப்பு',
'விவரங்கள்',
'நன்கொடை',
'கணக்கு இருப்பு',
'அனைத்தும்',
'செலுத்து',
'நன்கொடைத் தொகையை உள்ளிடவும்',
'உங்கள் நன்கொடைக்கு நன்றி'
  ],
  apply: {
    awardsTitle: "Awards",
    awardsContent: "Awards",
    pickUpVehicles: "{count} வாகனங்களை எடுக்கவும்"
  },
  positions:{
    info:['பதவி விவரங்கள்','பதவி விண்ணப்பம்','பதவி','நிலை 3 குழு G-நிலை வழக்கமான ஊழியர்கள்','மூன்றாம் நிலை குழு உறுப்பினர்களின் விகிதம்','இந்த மாத சம்பளம்', 'சம்பள தீர்வு', 'முடிக்கப்பட்டது', 'முடிக்கப்பட உள்ளது', 'பெறப்பட்டது','சம்பள வசூல் நேரம்'],
    job: ['மதிப்பாய்வுக்கு சமர்ப்பிக்கவும்','மதிப்பாய்வில் உள்ளது','மதிப்பாய்வு செய்யப்பட்டது','உங்கள் தொடர்புடைய ஆவணங்களை பதிவேற்றவும்','கருத்துகள்','உங்கள் ஐடி புகைப்படத்தைத் தேர்ந்தெடுத்து பதிவேற்ற படத்தின் மீது கிளிக் செய்யவும். ','புகைப்படம் A இல் உங்கள் ஐடி அட்டையின் முன்பக்கத்தின் புகைப்படத்தைப் பதிவேற்றவும். ','புகைப்படம் B இல் உங்கள் ஐடி அட்டையின் பின்புறத்தின் புகைப்படத்தைப் பதிவேற்றவும். ','புகைப்படம் C இல் உங்கள் ஐடி அட்டையை வைத்திருக்கும் உங்கள் புகைப்படத்தைப் பதிவேற்றவும். ','புகைப்படம் A','புகைப்படம் B','புகைப்படம் C','நீங்கள் பதவி உயர்வு பெற விரும்பும் பதவியைத் தேர்ந்தெடுக்கவும்','பதவி','அடிப்படை சம்பளம்','கூடுதல் போனஸ்','ஊழியர்களுக்கான அறிவிப்பு','《பதவி விண்ணப்ப வழிகாட்டுதல்கள்》','பதவி விண்ணப்பத்தைச் சமர்ப்பிக்கவும்','தயவுசெய்து ஒரு பதவியைத் தேர்ந்தெடுக்கவும்","புகைப்படம் A ஐத் தேர்ந்தெடுக்கவும்","தயவுசெய்து புகைப்பட B ஐத் தேர்ந்தெடுக்கவும்","தயவுசெய்து புகைப்பட C ஐத் தேர்ந்தெடுக்கவும்']
  },
  videoGuide: {
    title: 'வீடியோ பாடநெறி',
    brochure: 'சிற்றேடு',
    description: 'உலகளாவிய நகரமயமாக்கத்தின் வேகத்துடன், போக்குவரத்து நெரிசல் மற்றும் காலநிலை மாற்றம் முக்கியமான பொதுவான உலக சவால்களாக மாறியுள்ளன. இதன் விளைவாக, குறை கார்பன், திறமையான மற்றும் ஸ்மார்ட் போக்குவரத்து எதிர்கால நகரங்களின் வளர்ச்சிக்கான முக்கிய திசையாக மாறி வருகிறது. இந்த வரலாற்று பின்னணியில், Smart Green Mobility Share Inc. (சுருக்கமாக: SGM.S) 2023இல் அமெரிக்காவில் நிறுவப்பட்டது, பகிரப்பட்ட மைக்ரோ-மொபிலிட்டி (shared micro-mobility) துறையில் உலகின் முன்னணி தளத்தை உருவாக்கவும், பசுமை தொழில்நுட்பங்கள் மூலம் நகர போக்குவரத்து வளர்ச்சியை விரைவுபடுத்தவும் நோக்கமாகக் கொண்டுள்ளது.\n\nSGM.S பகிரப்பட்ட சைக்கிள் வாடகை சேவைகளில் கவனம் செலுத்துகிறது மற்றும் "பகிர்வு, ஸ்மார்ட் மற்றும் பூஜ்ஜிய கார்பன்" கொள்கைகளைப் பின்பற்றுகிறது. தொடர்ச்சியான புதுமைகள் மற்றும் உலகளாவிய விரிவாக்கம் மூலம், நிறுவனம் வசதியான, திறமையான மற்றும் நிலையான பசுமை போக்குவரத்து நெட்வொர்க்கை உருவாக்கி வருகிறது. தற்போது, நிறுவனத்தின் செயல்பாடுகள் ஐந்து கண்டங்களில் 30க்கும் மேற்பட்ட நாடுகள் மற்றும் பிராந்தியங்களை உள்ளடக்கியது, 280க்கும் மேற்பட்ட நகரங்களில் 300,000க்கும் மேற்பட்ட பகிரப்பட்ட மின்சார சைக்கிள்கள் மற்றும் மின்சார ஸ்கூட்டர்கள் அமர்த்தப்பட்டுள்ளன. நிறுவனம் உலகெங்கிலும் 8 மில்லியனுக்கும் மேற்பட்ட பயனர்களுக்கு சேவை செய்கிறது, தினசரி பசுமை பயணங்களின் எண்ணிக்கை 250,000ஐ எட்டுகிறது.\n\nமுக்கியமான உலகளாவிய வளர்ச்சி மூலோபாயத் திட்டங்களில் ஒன்றாக, SGM.S தஜிகிஸ்தான் சந்தையை தீவிரமாக விரிவுபடுத்தி வருகிறது. பகிரப்பட்ட மின்சார போக்குவரத்து மாதிரி மூலம், நிறுவனம் உள்ளூர் பசுமை போக்குவரத்து உருவாக்கத்தை ஆதரித்து நகர வளர்ச்சிக்கு நிலையான உந்துதலை வழங்குகிறது.\n\nஇணையம் ஆஃப் திங்ஸ் (IoT) மற்றும் செயற்கை நுண்ணறிவு (AI) தொழில்நுட்பங்களை நம்பியுள்ள SGM.S, நேரடி வாகன கண்காணிப்பு, புத்திசாலித்தனமான திட்டமிடல் மற்றும் முன்கணிப்பு தேவை மேலாண்மையை செயல்படுத்துகிறது. இது வாகன பயன்பாட்டு திறனை கணிசமாக அதிகரித்து, ஆற்றல் வீணடிப்பு மற்றும் செயல்பாட்டு கார்பன் உமிழ்வுகளை குறைக்கிறது. நிறுவனம் 2026க்குள் தனது செயல்பாடுகளில் முழுமையாக புதுப்பிக்கத்தக்க ஆற்றலைப் பயன்படுத்தவும், 2030க்குள் நிகர-பூஜ்ஜிய (Net-Zero) உமிழ்வு இலக்கை அடையவும் திட்டமிட்டுள்ளது.\n\nதற்போது, SGM.S சமூக பொறுப்புக்கு அதிக முக்கியத்துவம் அளிக்கிறது. தஜிகிஸ்தான் போன்ற சந்தைகளில், நிறுவனம் செயல்பாடு, தொழில்நுட்பம், வாடிக்கையாளர் சேவை மற்றும் பிற துறைகளில் 200,000க்கும் மேற்பட்ட வேலைவாய்ப்புகளை உருவாக்கி, உள்ளூர் விநியோக சங்கிலிகள் மற்றும் பிராந்திய பொருளாதார வளர்ச்சிக்கு ஆதரவளித்துள்ளது. அதே நேரத்தில், நிறுவனம் கல்வி ஆதரவு மற்றும் மருத்துவ உதவி போன்ற தொண்டு திட்டங்களில் தீவிரமாக பங்கேற்று, பகிரப்பட்ட போக்குவரத்து மற்றும் சமூக மதிப்புகளுக்கு உறுதியான அடித்தளத்தை அமைக்கிறது.\n\nமறுபுறம், SGM.S ஆன்லைன் வாகன வைப்புத் திட்டத்தை தொடங்கியுள்ளது. பயனர்கள் மொபைல் பயன்பாட்டின் மூலம் கடற்படை வள ஒதுக்கீடு மற்றும் பகிரப்பட்ட வாகன செயல்பாடுகளில் பங்கேற்கலாம். இது தள வளர்ச்சி மற்றும் பயனர் மதிப்பை ஒன்றாகப் பகிர்ந்து கொள்ளவும், பசுமை பொருளாதாரம் மற்றும் நிலையான எதிர்காலத்திற்கு ஒன்றாகப் பங்களிக்கவும் அனுமதிக்கிறது.\n\nSGM.S — பகிரப்பட்ட மின்சார போக்குவரத்தின் முன்னோடி, உலகின் நகரங்களை குறை கார்பன் அமைப்புகளுக்கு மாற்றுவதை விரைவுபடுத்துகிறது.'
  },
}